/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
* */

import React, {useState} from "react";
import PropTypes from "prop-types";

import AccordianItem from "./AccordianItem";

const propTypes = {
  content: PropTypes.string,
  title: PropTypes.string
};

const defaultProps = {
  content: "",
  title: ""
};

const AccordianItemContainer = ({
  content,
  title
}) => {
  const [toggled, setToggled] = useState(false);
  return (
    <AccordianItem
      content={content}
      setToggled={setToggled}
      title={title}
      toggled={toggled}
    />
  );
};

AccordianItemContainer.propTypes = propTypes;
AccordianItemContainer.defaultProps = defaultProps;

export default AccordianItemContainer;
